const destinations = new Set(['traceability', 'dashboard', 'dossier', 'declarations', 'payments', 'establishments', 'licenses', 'renewals', 'quittances', 'history', 'reports', 'settings']);
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function fptPortalUrl(sourceOrigin: string, hotelId: string, destination = 'dashboard', configured?: string): URL {
  const origins: Record<string, string> = {
    'https://hebergement.dief360.com': 'https://fpt.dief360.com',
    'https://devhotel.dief360.com': 'https://fpt.dev.dief360.com',
    'http://localhost:3000': 'http://localhost:3005',
  };
  const expected = origins[sourceOrigin];
  if (!expected || !uuidPattern.test(hotelId)) throw new Error('Établissement ou portail FPT non reconnu.');
  const target = new URL(configured || expected);
  if (target.origin !== expected || target.username || target.password) throw new Error('Adresse du portail FPT non autorisée.');
  target.pathname = '/' + (destinations.has(destination) ? destination : 'dashboard');
  target.search = '';
  target.searchParams.set('establishment_id', hotelId);
  target.hash = '';
  return target;
}

/** Transfer a session only to the exact trusted popup, never in its URL. */
export function openFptPortal(destination = 'dashboard', browser: Window = window, timeoutMs = 20000): Promise<void> {
  const hotelId = browser.localStorage.getItem('hotelId') || '';
  const token = browser.localStorage.getItem('token');
  if (!token) return Promise.reject(new Error('Votre session a expiré. Reconnectez-vous au portail hôtel.'));
  let target: URL;
  try { target = fptPortalUrl(browser.location.origin, hotelId, destination, process.env.REACT_APP_FPT_WARROOM_URL); }
  catch (error) { return Promise.reject(error); }
  const nonce = browser.crypto.randomUUID();
  target.hash = new URLSearchParams({ fpt_sso: nonce }).toString();
  return new Promise((resolve, reject) => {
    let popup: Window | null = null;
    let sent = false;
    let finished = false;
    const finish = (error?: Error) => {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      browser.removeEventListener('message', receive);
      if (error) reject(error); else resolve();
    };
    const receive = (event: MessageEvent) => {
      if (event.origin !== target.origin || !popup || event.source !== popup || event.data?.nonce !== nonce) return;
      if (event.data.type === 'FPT_SSO_READY' && !sent) {
        sent = true;
        popup.postMessage({ type: 'FPT_SSO_SESSION', nonce, token, hotelId }, target.origin);
      } else if (event.data.type === 'FPT_SSO_DONE' && sent) {
        finish();
      } else if (event.data.type === 'FPT_SSO_ERROR') {
        finish(new Error('La connexion au portail FPT a échoué. Réessayez depuis le portail hôtel.'));
      }
    };
    const timer = setTimeout(() => finish(new Error('Le portail FPT ne répond pas. Réessayez.')), timeoutMs);
    browser.addEventListener('message', receive);
    try { popup = browser.open(target.toString(), '_blank'); }
    catch { finish(new Error('Ouverture du portail FPT impossible. Réessayez.')); }
    if (!popup) finish(new Error('Autorisez l’ouverture du portail FPT dans un nouvel onglet.'));
  });
}
